import { Theme } from "@emotion/react";

import { ticketStatusLabels, TicketStatus } from "@megaron/support-contracts";

export const statusLabels = ticketStatusLabels;

export const warsawDateTimeFormatter = new Intl.DateTimeFormat("pl-PL", {
  timeZone: "Europe/Warsaw",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function getStatusTagStyle(theme: Theme, status: TicketStatus) {
  if (status === "open") {
    return { background: theme.colors.primaryLight, color: theme.colors.primary };
  }
  if (status === "pending") {
    return { background: theme.colors.hover, color: theme.colors.warning };
  }
  if (status === "resolved") {
    return { background: theme.colors.hover, color: theme.colors.success };
  }
  return { background: theme.colors.hover, color: theme.colors.secondaryText };
}
